import { apiClientWithRefreshToken } from "@/api/apiClient";
import { TermsAndCondition } from "@/v2/types";

export default async function FindOneTermsAndCondition(
    id: string,
): Promise<TermsAndCondition> {
    const res = await apiClientWithRefreshToken({
        url: `/terms-and-conditions-templates/${id}`,
        method: "GET",
    });
    return res.data;
}
